<template>
  <div class="rich-text-editor">
    <div ref="editor"></div>
  </div>
</template>

<script>
import quillEditorToolbar, { configureQuillLinks } from '../app/shared/quillEditorToolbar';

export default {
  name: 'RichTextEditor',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    label: { type: String, default: '' }
  },
  watch: {
    value(value) {
      this.syncValue(value);
    },
    placeholder(value) {
      if (this.quill) this.quill.root.dataset.placeholder = value;
    }
  },
  mounted() {
    this.quill = new Quill(this.$refs.editor, {
      modules: { toolbar: quillEditorToolbar },
      theme: 'snow',
      placeholder: this.placeholder
    });
    configureQuillLinks(this.quill);
    this.quill.root.setAttribute('role', 'textbox');
    this.quill.root.setAttribute('aria-multiline', 'true');
    this.quill.root.setAttribute('aria-label', this.label || this.placeholder);
    this.syncValue(this.value);
    this.onTextChange = () => {
      const html = this.quill.getLength() === 1 ? '' : this.quill.root.innerHTML;
      this.lastHtml = html;
      this.$emit('input', html);
      this.$emit('change', html);
    };
    this.quill.on('text-change', this.onTextChange);
  },
  beforeDestroy() {
    this.quill.off('text-change', this.onTextChange);
    this.quill.disable();
    this.quill = null;
  },
  methods: {
    syncValue(value) {
      if (!this.quill || value === this.lastHtml) return;
      this.quill.setContents(this.quill.clipboard.convert(value || ''), 'silent');
      this.quill.history.clear();
      this.lastHtml = value;
    }
  }
};
</script>

<style scoped>
.rich-text-editor ::v-deep .ql-editor {
  min-height: 150px;
}
</style>
